import React from 'react'

import { BaseView } from '@/components/base'
import { NotificationsList } from '@/components/NotificationsList'
import { EmptyNotifications } from '@/components/EmptyNotifications'
import { notifications } from '@/mock/notifications'
import useOffsets from '@/hooks/useOffsets'
import { StickyHeaderNavigation } from '@/components'
import { useTranslation } from 'react-i18next'

// Mock flag - exactly as in React Native
const isMock = false

export const NotificationsScreen: React.FC = () => {
  const offsets = useOffsets()
  const { t } = useTranslation()
  const notificationsData = isMock ? notifications : []
  const hasData = notificationsData.length > 0

  return (
    <BaseView
      style={{
        paddingTop: offsets.top,
        // paddingBottom: offsets.bottom,
        // paddingLeft: offsets.left,
        // paddingRight: offsets.right,
      }}
    >
      {/* Background image when no data - exactly as in React Native */}
      {!hasData && (
        <BaseView
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100vw',
            height: '100vh',
            backgroundImage: 'url(/assets/images/kem-desert.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: 0,
          }}
        />
      )}

      <BaseView
        fullWidth
        style={{
          // position: 'relative',
          zIndex: 1,
          padding: '0 0',
        }}
      >
        {/* Header Navigation - exactly as in React Native */}
        <StickyHeaderNavigation
          showBackground={false}
          title={t('translation:notifications')}
        />

        {/* Content */}
        {hasData && <NotificationsList data={notificationsData} />}
        {!hasData && <EmptyNotifications />}
      </BaseView>
    </BaseView>
  )
}
